module.exports = __webpack_public_path__ + "static/media/shipping-timed.2195707a.svg";